module.exports = __webpack_public_path__ + "img/bell.355f675d.svg";